<template>
  <suspense>
    <DynamicComponent v-bind="props" />
  </suspense>
</template>

<script setup lang="ts">
import { hydrateOnVisible, type HydrationStrategy } from 'vue';
import { pascalCase } from 'change-case';

const props = withDefaults(
  defineProps<{
    type: string;
    data: Record<string, any>;
    idPrefix?: string;
    pageMetrics?: Record<string, any>;
    transformation?: string;
    imageOptions?: Array<string>;
    hydrate?: HydrationStrategy;
  }>(),
  {
    idPrefix: '',
    pageMetrics: () => ({}),
    transformation: '',
    imageOptions: () => [],
    hydrate: hydrateOnVisible(),
  },
);

const importGlob = useComponentLoaderGlob(import.meta.glob('@/components/cms/components/*.vue'), {
  fallbackComponent: false,
});

const componentNameOverrides = {
  image_text_panel: 'ErrorIntro',
  related_posts_table: 'LinkTeaserList',
  videos: 'VideoGallery',
  actionbox: 'ActionBox',
};

const componentName = computed(() => {
  const name = props.type || '';

  return name in componentNameOverrides
    ? componentNameOverrides[name as keyof typeof componentNameOverrides]
    : pascalCase(name);
});

const DynamicComponent = computed(() => {
  return importGlob(`@/components/cms/components/Cms${unref(componentName)}.vue`);
});
</script>
